<template>

    <modal :show="showModal" @closeModal="close">

        <div class="modal-error-google-container">


            <template v-if="error === 'application_password' && !infoAppPass">

                <h1 class="c-title">☝</h1>

                <span class="c-text">{{ $t(`create_ap_password_description`) }}</span>

                <button class="btn btn-blue" @click="tagClick('next__gmail_error_app_password');step2()">{{ $t(`login_create_app_password`) }}
                </button>

            </template>


            <template v-if="error === 'invalid_credentials' && !infoAppPass">

                <h1 class="c-title">{{ $t(`invalid_credential_title`) }}</h1>

                <span class="c-text">{{ $t(`invalid_credential_text_check_login`) }}</span>

                <span class="c-text">{{ $t(`invalid_credential_text_check_imap`) }}</span>

                <button class="btn btn-blue meg-btn-first" @click="close">{{ $t('invalid_credential_cta_try_again') }}</button>

                <button class="btn btn-text meg-btn-twice" @click="tagClick('next_gmail_error_invalid_credential');goImapDisable()">{{ $t(`invalid_credential_cta_activate_imap`) }}
                </button>

            </template>


            <template v-if="error === 'imap_disabled' && !infoAppPass">

                <h1 class="c-title">{{ $t(`imap_disabled_title`) }}</h1>

                <span class="c-text c-text-list">{{ $t(`imap_disabled_text_open`) }}</span>

                <span class="c-text c-text-list">{{ $t(`imap_disabled_text_parameters`) }}</span>

                <span class="c-text c-text-list">{{ $t(`imap_disabled_text_click_imap`) }}</span>

                <span class="c-text c-text-list">{{ $t(`imap_disabled_text_activate_imap`) }}</span>

                <span class="c-text c-text-list">{{ $t(`imap_disabled_text_save`) }}</span>

                <button class="btn btn-blue meg-btn-first" @click="close">{{ $t(`imap_disabled_cta`) }}</button>

            </template>


            <template v-if="infoAppPass">

                <h1 class="c-title">{{ $t(`ModalErrorGoogle.info_app_pass.title`) }}</h1>

                <span class="c-text c-text-list c-step">{{ $t(`ModalErrorGoogle.info_app_pass.text_1`) }}</span>

                <span class="c-text c-text-list"
                      v-html="$tc(`ModalErrorGoogle.info_app_pass.text_2`, 0, { link: `<a class='link' target='_blank' href='${ $t('ModalErrorGoogle.info_app_pass.link') }'>${ $t('ModalErrorGoogle.info_app_pass.cta_google') }</a>` })"></span>

                <span class="c-text c-text-list c-step">{{ $t(`ModalErrorGoogle.info_app_pass.text_3`) }}</span>

                <span class="c-text c-text-list">{{ $t(`ModalErrorGoogle.info_app_pass.text_4`) }}</span>

                <span class="c-text c-text-list c-step">{{ $t(`ModalErrorGoogle.info_app_pass.text_5`) }}</span>

                <span class="c-text c-text-list">{{ $t(`ModalErrorGoogle.info_app_pass.text_6`) }}</span>

                <button class="btn btn-blue" @click="closeAppPass">{{ $t(`ModalErrorGoogle.info_app_pass.cta`) }}</button>

            </template>

        </div>

    </modal>

</template>

<script>

import Tag from '@/modules/tag'

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-error-google',

    components: { Modal },

    data () {
        return {
            showModal: false,
            error: '',
            infoAppPass: false,
        }
    },

    methods: {

        open (error) {
            switch (error) {
                case 'application_password':
                    Tag.popupAmplitude(this, 'login_gmail_error_app_password')
                    break
                case 'imap_disabled':
                    Tag.popupAmplitude(this, 'login_gmail_error_imap_disabled')
                    break
            }

            this.error = error
            this.showModal = true
        },

        close (emit = true) {

            if (!this.infoAppPass) {

                switch (this.error) {

                    case 'invalid_credentials':
                        Tag.clickAmplitude(this, 'back_gmail_error_invalid_credential')
                        break
                    case 'application_password':
                        Tag.clickAmplitude(this, 'back_gmail_error_app_password')
                        break
                    case 'imap_disabled':
                        Tag.clickAmplitude(this, 'back_gmail_error_imap_disabled')
                        break
                }

            } else if (this.infoAppPass) {

                Tag.clickAmplitude(this, 'back_info_app_pass')

            }

            if (emit) {
                this.$emit('close')
            }

            this.showModal = false
            this.infoAppPass = false
        },

        tagClick (value) {

            Tag.clickAmplitude(this, value)

        },

        goImapDisable () {

            this.error = 'imap_disabled'
        },

        closeAppPass () {
            Tag.clickAmplitude(this, 'info_google_app_2_next')
            // window.open('https://myaccount.google.com/apppasswords')
            this.close()
        },

        step2 () {

            this.$emit('goAppPass')
            this.close(false)
        },

        createAppPass () {
            Tag.clickAmplitude(this, 'info_google_app_2')
            this.infoAppPass = true
        }
    }

}

</script>

<style scoped lang="scss">

    .modal-error-google-container {
        position: relative;
        padding: 32px 16px 16px;
        display: flex;
        flex-direction: column;
        max-width: 450px;
    }

    .modal-error-google-container > * {
        margin: 16px 0;
    }

    .c-title {
        font-size: 21px;
        font-weight: bold;
        line-height: 1.14;
        color: $midnight;
    }

    .c-text {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        color: $secur-text;
    }

    .c-text-list {
        text-align: left;
    }

    .c-step {
        font-size: 18px;
        font-weight: 500;
        color: #32a3eb;
        margin: 5px 0 0;
    }

    .meg-btn-first {
        margin: 17px 0 0;
    }

    .meg-btn-twice {
        margin-top: 8px 0 0;
    }

</style>
